import 'vue3-loading-overlay/dist/vue3-loading-overlay.css'

import 'ant-design-vue/dist/reset.css'
import './styles/index.ts'

import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './plugins/axios.js'

import * as Sentry from '@sentry/vue'

const app = createApp(App)

if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    app,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    release: import.meta.env.VITE_SENTRY_RELEASE,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.browserTracingIntegration({
        router
      }),
      Sentry.replayIntegration({ maskAllText: false }),
      Sentry.extraErrorDataIntegration(),
      Sentry.captureConsoleIntegration({ levels: ['error'] })
    ],
    environment: import.meta.env.NODE_ENV || 'development',
    sendDefaultPii: true,
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0
  })
}

app.use(router)

app.mount('#app')
